var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1603 5.98276V18H1V1H8.06379L14.1603 5.98276Z",
    stroke: "#D86262",
    strokeWidth: 0.87931,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10938 9.5H11.0852",
    stroke: "#D86262",
    strokeWidth: 0.87931,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10938 12.1953H11.0852",
    stroke: "#D86262",
    strokeWidth: 0.87931,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10938 14.9766H11.0852",
    stroke: "#D86262",
    strokeWidth: 0.87931,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1904 6.42225H8.65075H7.85938V1.35156",
    stroke: "#D86262",
    strokeWidth: 0.87931,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentRedIcon);
export default __webpack_public_path__ + "static/media/Document-Red-Icon.c001052d72e93eb0ae0cbf6bda172471.svg";
export { ForwardRef as ReactComponent };